// extracted by mini-css-extract-plugin
export default {"form-crud":"form-crud_form-crud__31vJv","card__title":"form-crud_card__title__reNdy","form__script_field":"form-crud_form__script_field__c5Stl"};